import React, { Component } from "react";

export default class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      message: "",
      messageSent: false,
      validateFields: false
    };
  }
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleSubmit = e => {
    e.preventDefault();
    // e.target.reset();

    const { name, message } = this.state;

    if (name !== "" && message !== "") {
      const template_params = {
        from_name: name,
        message: message
      };

      const service_id = "default_service";
      const template_id = "portoflio";
      window.emailjs.send(service_id, template_id, template_params);

      this.setState({
        name: "",
        message: "",
        messageSent: true,
        validateFields: false
      });
    } else {
      this.setState({
        validateFields: true
      });
    }
  };

  render() {
    return (
      <div className="form mt-1 mb-1 d-flex">
        <div className="contact__form col">
          <form method="post" onSubmit={this.handleSubmit}>
            <label htmlFor="name" className="contact__form-label text-white">
              <i className="fas fa-user contact__form-icon" /> Name
            </label>
            <input
              type="text"
              required
              name="name"
              placeholder="Name"
              className="contact__form-input"
              onChange={this.handleChange}
            />

            <label htmlFor="message" className="contact__form-label text-white">
              <i className="fas fa-comment-alt contact__form-icon" /> Message
            </label>
            <textarea
              required
              name="message"
              className="contact__form-input contact__form-input-textarea"
              placeholder="Message"
              id="message"
              onChange={this.handleChange}
            />
            {this.state.validateFields ? (
              <p className="text-content-2 text-white">
                Name and Message must be informed!
              </p>
            ) : null}
            {this.state.messageSent ? (
              <p className="text-content-2 text-white">
                Message sent, Thank you!
              </p>
            ) : (
              <button className="contact__form-btn">Send</button>
            )}
          </form>
        </div>
        <div className="form col">
          <div className="form-bg" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactForm.js